import { motion } from 'framer-motion'
import { Users, Clock, MapPin } from 'lucide-react'
import type { Booking } from '@/lib/types/booking'
import { BookingStatusBadge } from './BookingStatusBadge'

interface BookingCardProps {
  booking: Booking
  onClick: () => void
}

export function BookingCard({ booking, onClick }: BookingCardProps) {
  return (
    <motion.button
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.25, 0.46, 0.45, 0.94] }}
      layout
      onClick={onClick}
      className="flex items-center gap-4 w-full rounded-[var(--radius-md)] p-4 bg-[var(--color-bg-surface)] border border-[var(--color-border-subtle)] hover:border-[var(--color-border-default)] transition-all text-left cursor-pointer"
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-bg-elevated)] text-sm font-semibold text-[var(--color-text-primary)] shrink-0">
        {(booking.guest?.name ?? 'W').charAt(0).toUpperCase()}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-sm font-medium text-[var(--color-text-primary)] truncate">
            {booking.guest?.name ?? 'Walk-in'}
          </span>
          <BookingStatusBadge status={booking.status} />
          {booking.source === 'she_answers' && (
            <span className="shrink-0 rounded-full bg-purple-600 px-2 py-0.5 text-[10px] font-medium text-white">
              SheAnswers
            </span>
          )}
        </div>
        <div className="flex items-center gap-3 text-xs text-[var(--color-text-muted)]">
          <span>{booking.time}</span>
          <span className="flex items-center gap-1"><Users className="h-3 w-3" />{booking.people}</span>
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" />{booking.duration}m</span>
          {booking.bookingTables && booking.bookingTables.length > 0 && (
            <span className="flex items-center gap-1">
              <MapPin className="h-3 w-3" />
              {booking.bookingTables.map((bt) => bt.name).join(', ')}
            </span>
          )}
        </div>
      </div>
    </motion.button>
  )
}
